import comp from "./DeleteSectionModal";
export default comp;
